// Iconos de linea (usan el color del texto: currentColor) para botones.
const base = { width: 14, height: 14, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round', 'aria-hidden': true };

export const IconoLapiz = ({ size = 14 }) => (
  <svg {...base} width={size} height={size}><path d="M12 20h9" /><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z" /></svg>
);
export const IconoCheck = ({ size = 14 }) => (
  <svg {...base} width={size} height={size}><path d="m5 12 5 5L20 7" /></svg>
);
export const IconoCerrar = ({ size = 14 }) => (
  <svg {...base} width={size} height={size}><path d="M18 6 6 18M6 6l12 12" /></svg>
);
export const IconoRayo = ({ size = 14 }) => (
  <svg {...base} width={size} height={size}><path d="M13 2 4 14h7l-1 8 9-12h-7z" /></svg>
);
